// Author Lin
// Date 2022-05-26 18:03:32

class SithMesInventoryPackingBom {
constructor({
        id = null,
        itemId = '',
        materialCode = '',
        description = '',
        unit = '',
        quantity = '',
        status = '',
        remark = ''}
= {}) {
    this.id = id;
    this.itemId = itemId;
    this.materialCode = materialCode;
    this.description = description;
    this.unit = unit;
    this.quantity = quantity;
    this.status = status;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesInventoryPackingBom();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.inventory.sithMesInventoryPackingBom.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'itemId',
        label: 'label.sith.inventory.sithMesInventoryPackingBom.grid.itemId',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'purchaseNumber',
        label: 'label.sith.inventory.sithMesInventoryPackingBom.grid.purchaseNumber',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'itemCode',
        label: 'label.sith.inventory.sithMesInventoryPackingBom.grid.itemCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'vendorName',
        label: 'label.sith.inventory.sithMesInventoryPackingBom.grid.vendorName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'materialCode',
        label: 'label.sith.inventory.sithMesInventoryPackingBom.grid.materialCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'description',
        label: 'label.sith.inventory.sithMesInventoryPackingBom.grid.description',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'unit',
        label: 'label.sith.inventory.sithMesInventoryPackingBom.grid.unit',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'quantity',
        label: 'label.sith.inventory.sithMesInventoryPackingBom.grid.quantity',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'status',
        label: 'label.sith.inventory.sithMesInventoryPackingBom.grid.status',
        sortable: true,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
        ,options: [
                { value: '1', text: '已到货' },
                            { value: '2', text: '已过103' },
                            { value: '3', text: '已退104' },
                            { value: '4', text: '已过105' },
                            { value: '5', text: '已退106' },
                            { value: '6', text: '已入库' }
            ]
        }
        },
        {
        key: 'remark',
        label: 'label.sith.inventory.sithMesInventoryPackingBom.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    itemIdFilter : '',
    purchaseNumberFilter : '',
    itemCodeFilter : '',
    materialCodeFilter : '',
    descriptionFilter : '',
    unitFilter : '',
    quantityFilter : '',
    statusFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'itemIdFilter',
        label: 'label.sith.inventory.sithMesInventoryPackingBom.filter.itemId',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'sithMesInventoryItem'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'purchaseNumberFilter',
        label: 'label.sith.inventory.sithMesInventoryPackingBom.filter.purchaseNumber',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'itemCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryPackingBom.filter.itemCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'materialCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryPackingBom.filter.materialCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'descriptionFilter',
        label: 'label.sith.inventory.sithMesInventoryPackingBom.filter.description',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'unitFilter',
        label: 'label.sith.inventory.sithMesInventoryPackingBom.filter.unit',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'quantityFilter',
        label: 'label.sith.inventory.sithMesInventoryPackingBom.filter.quantity',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'statusFilter',
        label: 'label.sith.inventory.sithMesInventoryPackingBom.filter.status',
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '已到货' },
                { value: '2', text: '已过103' },
                { value: '3', text: '已退104' },
                { value: '4', text: '已过105' },
                { value: '5', text: '已退106' },
                { value: '6', text: '已入库' }
            ]
        }
        }
];


    const entityFormConfigs = [
        {
        key: 'itemId',
        label: 'label.sith.inventory.sithMesInventoryPackingBom.entity.itemId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,required: true
            ,entity: 'sithMesInventoryItem'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'materialCode',
        label: 'label.sith.inventory.sithMesInventoryPackingBom.entity.materialCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'description',
        label: 'label.sith.inventory.sithMesInventoryPackingBom.entity.description',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'unit',
        label: 'label.sith.inventory.sithMesInventoryPackingBom.entity.unit',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'quantity',
        label: 'label.sith.inventory.sithMesInventoryPackingBom.entity.quantity',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'status',
        label: 'label.sith.inventory.sithMesInventoryPackingBom.entity.status',
        sortable: true,
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
        ,options: [
                { value: '1', text: '已到货' },
                { value: '2', text: '已过103' },
                { value: '3', text: '已退104' },
                { value: '4', text: '已过105' },
                { value: '5', text: '已退106' },
                { value: '6', text: '已入库' }
            ]
        }
        },
        {
        key: 'remark',
        label: 'label.sith.inventory.sithMesInventoryPackingBom.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        }
]

export {SithMesInventoryPackingBom, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
